/* eslint-disable no-mixed-spaces-and-tabs */
import { ComponentData } from '../components/types';
// import { componentSvg } from './component-svg';

export type ComponentDataCallback = () => Record<string, ComponentData>;

export interface ComponentOptions {
  userEmail?: string;
  callback?: ComponentDataCallback;
}

export class ComponentItemData {
  private static instance: ComponentItemData;
  private data: Record<string, ComponentData> = {};
  private callback: ComponentDataCallback | null = null;
  private userEmail?: string;

  constructor (options?: ComponentOptions) {
  	this.userEmail = options?.userEmail;

  	if (options?.callback) {
  		this.callback = options.callback;
  		this.loadData();
  		console.log('compoennt-item-data', this);
  	}
  }

  static getInstance (options?: ComponentOptions): ComponentItemData {
  	if (!ComponentItemData.instance && options) {
  		ComponentItemData.instance = new ComponentItemData(options);
  	}
  	return ComponentItemData.instance;
  }

  /**
   * Set the callback function that provides the component data
   */
  static setCallback (callback: ComponentDataCallback): void {
  	ComponentItemData.getInstance().callback = callback;
  	ComponentItemData.getInstance().loadData();
  }

  /**
   * Get all component data
   */
  static getData (): Record<string, ComponentData> {
  	return ComponentItemData.instance?.data ?? {};
  }

  /**
   * Get component data by SKU
   */
  static getDataBySku (sku: string): ComponentData | null {
  	return ComponentItemData.instance?.data[sku] || null;
  }

  /**
   * Get component data by ID
   */
  static getDataById (id: string): ComponentData | null {
  	if (!ComponentItemData.instance) return null;
  	return Object.values(ComponentItemData.instance.data).find((component) => component.id === id) || null;
  }

  /**
   * Get all SKUs
   */
  static getAllSkus (): string[] {
  	return Object.keys(ComponentItemData.instance?.data ?? {});
  }

  /**
   * Get components by category
   */
  static getComponentsByCategory (categoryId: string): Record<string, ComponentData> {
  	if (!ComponentItemData.instance) return {};
  	const instance = ComponentItemData.instance;
  	const categoryComponents: Record<string, ComponentData> = {};

  	Object.entries(instance.data).forEach(([sku, component]) => {
  		if (component.categoryId === categoryId) {
  			categoryComponents[sku] = component;
  		}
  	});

  	return categoryComponents;
  }

  /**
   * Add or update a component
   */
  static addComponent (sku: string, componentData: ComponentData): void {
  	ComponentItemData.getInstance().data[sku] = componentData;
  }

  /**
   * Remove a component
   */
  static removeComponent (sku: string): boolean {
  	const instance = ComponentItemData.getInstance();
  	if (instance.data[sku]) {
  		delete instance.data[sku];
  		return true;
  	}
  	return false;
  }

  /**
   * Load data using the registered callback
   */
  private loadData (): void {
  	if (this.callback) {
  		const rawData = this.callback();
  		// Ensure msrp is a number (API might return strings)
  		this.data = Object.fromEntries(
  			Object.entries(rawData).map(([sku, item]) => [
  				sku,
  				{ ...item, msrp: Number(item.msrp) || 0 }
  			])
  		);
  	}
  }

  /**
   * Reload data (useful for refreshing data)
   */
  static reload (): void {
  	ComponentItemData.getInstance().loadData();
  }

  /**
   * Clear all data
   */
  static clear (): void {
  	ComponentItemData.getInstance().data = {};
  }
}
